(() => {
  const enhancerScript = document.currentScript;
  if (!enhancerScript || enhancerScript.dataset.mfDoranInitialized === 'true') return;
  enhancerScript.dataset.mfDoranInitialized = 'true';

  const initialCount = Math.max(1, Number(enhancerScript.dataset.initialCount) || 5);
  const batchSize = Math.max(1, Number(enhancerScript.dataset.batchSize) || 5);
  const anchor = enhancerScript.previousElementSibling;
  const externalButton = document.querySelector('[data-mf-doran-load-more]');
  const externalButtonWrap = document.querySelector('[data-mf-doran-load-more-wrap]');
  let attempts = 0;
  let started = false;

  const findReviewFrame = () => {
    const anchorSection = anchor?.closest('.shopify-section');
    let section = anchorSection?.nextElementSibling;

    while (section) {
      const frame = section.querySelector('#doran-product-widget iframe[title="Product Reviews"]');
      if (frame) return frame;
      section = section.nextElementSibling;
    }

    return document.querySelector('#doran-product-widget iframe[title="Product Reviews"]');
  };

  const install = (frame) => {
    let frameDocument;
    try {
      frameDocument = frame.contentDocument;
    } catch (_) {
      return false;
    }
    // New products need the native skin before their first review exists.
    // The observer below also picks up review cards that Doran hydrates later.
    if (!frameDocument?.head || !frameDocument.body || !frameDocument.querySelector('.frame-content')) return false;
    if (frame.__mfDoranEnhancedDocument === frameDocument) return true;

    frame.__mfDoranEnhancedDocument = frameDocument;
    frame.dataset.mfDoranEnhanced = 'true';
    let visibleCount = initialCount;
    frameDocument.body.dataset.mfDoranVisibleCount = String(initialCount);
    let awaitingNativePage = false;
    let nativeTargetCount = 0;
    let lastCardCount = 0;
    let refreshQueued = false;

    const style = frameDocument.createElement('style');
    style.dataset.mfDoranStyles = 'true';
    style.textContent = `
      :root {
        --mf-review-accent: #3b49be;
        --mf-review-star: #e3a233;
        --mf-review-ink: #10131c;
        --mf-review-muted: #65708e;
        --mf-review-line: #dbe1ee;
        --mf-review-paper: #fbfcfe;
      }
      body {
        margin: 0;
        color: var(--mf-review-ink);
        background: var(--mf-review-paper);
        font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }
      .frame-content { width: min(100% - 32px, 1200px); margin-inline: auto; }
      .text-rating { color: var(--mf-review-star) !important; }
      .bg-rating { background: var(--mf-review-star) !important; }
      .bg-button-background { background: var(--mf-review-accent) !important; }
      .focus\\:ring-button-background:focus { --tw-ring-color: var(--mf-review-accent) !important; }
      .review-section-heading p { font-size: clamp(1.75rem, 4vw, 2.5rem); letter-spacing: -0.035em; }
      .review-section-summary,
      .review-form-rating,
      .review-listing { border-color: var(--mf-review-line) !important; }
      .review {
        border-color: var(--mf-review-line) !important;
        background: #fff !important;
        box-shadow: 0 16px 40px -36px rgba(16, 19, 28, .55);
      }
      .review[hidden] { display: none !important; }
      @media (max-width: 767px) {
        .frame-content { width: min(100% - 24px, 1200px); }
        .review-section-heading { padding-top: 24px !important; padding-bottom: 18px !important; }
        .review-section-summary > div { padding-block: 20px !important; }
        .review-listing { padding-block: 22px !important; }
        .review { border-radius: 14px !important; }
      }
    `;
    frameDocument.head.appendChild(style);

    const getList = () => {
      const listing = frameDocument.querySelector('.review-listing');
      if (!listing) return null;
      return Array.from(listing.children).find((child) => child.querySelector(':scope > .review'));
    };

    const getCards = (list) => Array.from(list?.children || []).filter((child) => child.classList.contains('review'));

    const getNativeMore = (list) => {
      if (!list) return null;
      return Array.from(list.children).find((child) => {
        if (child.classList.contains('review') || child.classList.contains('mf-doran-load-more-wrap')) return false;
        return /view more reviews|load more reviews/i.test(child.textContent || '');
      });
    };

    const queueRefresh = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        refresh();
      });
    };

    const requestNativePage = (nativeMore, button) => {
      const nativeButton = nativeMore?.querySelector('button');
      if (!nativeButton || awaitingNativePage) return;

      awaitingNativePage = true;
      nativeTargetCount = visibleCount + batchSize;
      button.disabled = true;
      button.textContent = 'Loading reviews…';
      nativeButton.click();

      window.setTimeout(() => {
        awaitingNativePage = false;
        queueRefresh();
      }, 4000);
    };

    const handleLoadMore = (event) => {
      event.preventDefault();
      const currentList = getList();
      const currentCards = getCards(currentList);
      const currentNativeMore = getNativeMore(currentList);

      if (visibleCount < currentCards.length) {
        visibleCount = Math.min(currentCards.length, visibleCount + batchSize);
        frameDocument.body.dataset.mfDoranVisibleCount = String(visibleCount);
        queueRefresh();
      } else if (currentNativeMore) {
        requestNativePage(currentNativeMore, externalButton);
      }
    };

    const refresh = () => {
      const list = getList();
      if (!list) return;

      visibleCount = Math.max(
        initialCount,
        Number(frameDocument.body.dataset.mfDoranVisibleCount) || visibleCount
      );
      const cards = getCards(list);
      const nativeMore = getNativeMore(list);
      if (cards.length > lastCardCount && awaitingNativePage) {
        visibleCount = Math.min(cards.length, nativeTargetCount);
        frameDocument.body.dataset.mfDoranVisibleCount = String(visibleCount);
        if (cards.length >= nativeTargetCount) awaitingNativePage = false;
      }
      lastCardCount = cards.length;

      cards.forEach((card, index) => {
        card.hidden = index >= visibleCount;
      });

      if (nativeMore) nativeMore.hidden = true;

      const hasLocallyHidden = visibleCount < cards.length;
      const hasNativePage = Boolean(nativeMore);
      if (externalButtonWrap) externalButtonWrap.hidden = !hasLocallyHidden && !hasNativePage;
      if (externalButton && !awaitingNativePage) {
        externalButton.disabled = false;
        externalButton.textContent = 'Load more reviews';
      }
    };

    if (externalButton) {
      externalButton.setAttribute('aria-controls', 'doran-product-widget');
      externalButton.onclick = handleLoadMore;
    }

    frameDocument.addEventListener('click', (event) => {
      if (event.target.closest('.filter-button, [class*="filter-button-"], [class*="sort"]')) {
        visibleCount = initialCount;
        frameDocument.body.dataset.mfDoranVisibleCount = String(initialCount);
        window.setTimeout(queueRefresh, 50);
      }
    }, true);

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList')) queueRefresh();
    });
    observer.observe(frameDocument.body, { childList: true, subtree: true });
    refresh();
    return true;
  };

  const tryInstall = () => {
    const frame = findReviewFrame();
    if (frame && frame.dataset.mfDoranLoadBound !== 'true') {
      frame.dataset.mfDoranLoadBound = 'true';
      frame.addEventListener('load', tryInstall);
    }
    if (frame && install(frame)) return;
    attempts += 1;
    if (attempts < 60) window.setTimeout(tryInstall, 250);
  };

  const start = () => {
    if (started) return;
    started = true;
    tryInstall();
  };

  const observe = () => {
    if (!anchor || !('IntersectionObserver' in window)) {
      start();
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      start();
    }, { rootMargin: '800px 0px' });
    observer.observe(anchor);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
